import { useState } from 'react';
import { useDrawer } from '../../../shared/drawer';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
import { CompaniaAseguradoraForm } from './compania-aseguradora-form';


export const CompaniaAseguradora = () => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);




    const handleNewAction = () => {
        open('common.label.nueva-compania-aseguradora', <CompaniaAseguradoraForm close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.label.compania-aseguradora'}
            newActionTitle={'common.label.nueva-compania-aseguradora'}
        >
            <>
                <Table
                    path="/fleet/insurance-companies/"
                    deletePath="/fleet/insurance-companies/"
                    callBeforeDrawerClosed={handleClose}
                    Form={CompaniaAseguradoraForm}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'name',
                            label: 'common.form-label.name'
                        }
                    ]}
                />
            </>
        </PageBody>
    );
};